import React from "react";
import { Image } from "../../../Models/Image";
import "../../../Styles/ImageGallery.scss";
import { ImagePreviewModal } from "../ImagePreviewModal";

type Props = {
  image: Image;
};

type State = {
  showPreview: boolean;
};

export default class ImageGalleryItem extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      showPreview: false
    };
  }

  togglePreview = () => {
    this.setState(prevState => ({
      showPreview: !prevState.showPreview
    }));
  };

  render() {
    return (
      <>
        <a onClick={this.togglePreview} title="Click to expand" style={{ cursor: "pointer" }}>
          <div className="gallery-item">
            <img src={this.props.image.thumbnailUrl} alt="Unable to get image from server" />
            {this.props.children}
          </div>
        </a>
        <ImagePreviewModal
          isOpen={this.state.showPreview}
          toggle={this.togglePreview}
          image={this.props.image}
        />
      </>
    );
  }
}
